import React from "react";
import EmployeeAssets from "../../../commons/Employees/AssetsManagement/EmployeeAssets";

const ServiceProviderAssetsManagement = () => {
  return (
    <>
      <EmployeeAssets serviceProvider={true} />
    </>
  );
};

export default ServiceProviderAssetsManagement;
